import { INSURANCE_COMPANIES_PARTNER_FILTER_EVENTS } from '../../config';

export default {
  created() {
    const unwatch = this.$store.watch(
      (_, getters) => getters['currentUserModule/getCurrentUserId'],
      (newVal) => {
        if (newVal) {
          this.partnerFilterOptions.splice(1, 0, {
            id: newVal,
            name: 'Тільки головна точка',
            event: INSURANCE_COMPANIES_PARTNER_FILTER_EVENTS.INSURANCE_COMPANIES_PARTNER_FILTER_MAIN,
            options: {
              type: 'checkbox',
              multiselect: false,
            }
          });

          this.$eventBus.$on(
            INSURANCE_COMPANIES_PARTNER_FILTER_EVENTS.INSURANCE_COMPANIES_PARTNER_FILTER_MAIN,
            (item) => { this.setSelectedFilter('partner', item.id); }
          );

          unwatch();
        }
      }
    );
  },
  beforeDestroy() {
    this.$eventBus.$off(
      INSURANCE_COMPANIES_PARTNER_FILTER_EVENTS.INSURANCE_COMPANIES_PARTNER_FILTER_MAIN,
      (item) => { this.setSelectedFilter('partner', item.id); }
    );
  }
};
